import { render, staticRenderFns } from "./HolidayName.vue?vue&type=template&id=466696a2&"
import script from "./HolidayName.vue?vue&type=script&lang=js&"
export * from "./HolidayName.vue?vue&type=script&lang=js&"
import style0 from "./HolidayName.vue?vue&type=style&index=0&id=466696a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports